import { Component, inject } from '@angular/core';
import { AuthService } from '@common/core/services';

@Component({
  selector: 'busitalia-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: false,
})
export class HeaderComponent {
  authService = inject(AuthService);

  onLogout() {
    this.authService.signOut();
  }
}
